import React from 'react';
import {decodeEntities} from '@wordpress/html-entities';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const { getSetting } = window.wc.wcSettings

const settings = getSetting( 'spgw_alipay_data', {} );
const label = decodeEntities( settings.title );

// const Content = () => {
// 	return decodeEntities( settings.description || '' );
// }
const ContentComponent = () => {
	return <div>{decodeEntities( settings.description || '' )}</div>;
  };
const Icon = () => {
	return settings.icon 
		? <img src={settings.icon} style={{ float: 'right', marginRight: '20px' }} /> 
		: '';
};
const Label = () => {
	return (
		<span style={{ width: '100%' }}>
			{label}
			<Icon />
		</span>
	);
};


registerPaymentMethod( {
	name: "spgw_alipay",
	label: <Label />,
	content: <ContentComponent />,
  	edit: <ContentComponent />,
	canMakePayment: () => true,
	ariaLabel: label,
	supports: {
		features: settings.supports,
    showSavedCards: true,
    showSaveOption: true
	}
} )

